import { FunctionComponent, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import moment, { Moment } from 'moment-timezone';
import Calendar from 'react-calendar';
import { Value } from 'react-calendar/dist/cjs/shared/types';

import styles from './VaccineApprovalDatePicker.module.scss';

interface VaccineApprovalDatePickerProps {
    timeZone: string;
    value?: Moment | null;
    onChange?: (value: Moment | null) => void;
}

const toDate = (value: Moment): Date => new Date(value.year(), value.month(), value.date());

const VaccineApprovalDatePicker: FunctionComponent<VaccineApprovalDatePickerProps> = ({
    timeZone,
    value,
    onChange
}) => {
    const calendarValue = useMemo(() => (value ? toDate(value) : null), [value]);

    const handleChange = (calendarValue: Value) => {
        if (!calendarValue || !(calendarValue instanceof Date)) {
            onChange?.(null);
            return;
        }

        onChange?.(moment(calendarValue).tz(timeZone, true));
    };

    return (
        <div className={styles.root}>
            <Calendar
                locale="en-US"
                calendarType="iso8601"
                minDetail="month"
                maxDetail="month"
                prev2Label={null}
                next2Label={null}
                showNeighboringMonth={false}
                className={styles.calendar}
                prevLabel={<FontAwesomeIcon icon={faAngleLeft} />}
                nextLabel={<FontAwesomeIcon icon={faAngleRight} />}
                formatMonthYear={(_locale, date) => date.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
                formatShortWeekday={(_locale, date) =>
                    date.toLocaleString('en-US', { weekday: 'short' }).replace(/\./g, '').slice(0, 2)
                }
                value={calendarValue}
                onChange={handleChange}
            />
        </div>
    );
};

export default VaccineApprovalDatePicker;
